import React, { useState } from "react";
import Modal from "components/base/Modal";
import classNames from "classnames";
import css from "../style.scss";
import { useDispatch, useSelector } from "react-redux";
import { selectCallDNCLitigator, selectCallDNC, selectCallLitigator } from "data/user/selectors";

const CallDncLitigator = ({ isOpen, onClose, onSuccess, integrationId, complianceType }) => {

    const [isSubmitting, setIsSubmitting] = useState(false);
    const isDNC = useSelector(selectCallDNC);
    const isLitigator = useSelector(selectCallLitigator);
    const isDNCLitigator = useSelector(selectCallDNCLitigator);


    return (
        <>
            <Modal
                isOpen={isOpen}
                onClose={onClose}
                uniqId="CallDncLitigator"
                width="auto"
                padding="0"
                zIndex={998}
                modalClassName={css.pricingModal}
                className={classNames(css.clsAccPageModals, css.clsBillingModal)}
            >
                <div className={classNames(css.modal_lg, "modal-dialog modal-lg m-0 modal-dialog-scrollable")}>
                    <div className={classNames(css.clsModalContent, "modal-content")}>
                        <div className={classNames(css.removeBatchDialerModal, "modal-body")}>
                            {/* DNC + Litigator */}
                            {complianceType === "both" && (
                                <div className={css.rbModalTextGroup}>
                                    <div className={css.rbModalTitle}>Call DNC Number of Litigator?</div>
                                    <div className={css.rbModalDetails}>
                                        This person is a Litigator and the number is on the <br />
                                        Do Not Call (DNC) list. Are you sure you want to <br />
                                        proceed?
                                    </div>
                                </div>
                            )}

                            {/* DNC only */}
                            {complianceType === "dnc" && (
                                <div className={css.rbModalTextGroup}>
                                    <div className={css.rbModalTitle}>Call DNC Number?</div>
                                    <div className={css.rbModalDetails}>
                                        This number is on the Do Not Call (DNC) list. Are <br />
                                        you sure you want to proceed?
                                    </div>
                                </div>
                            )}

                            {/* Litigator only */}
                             {complianceType === "litigator" && (
                                <div className={css.rbModalTextGroup}>
                                    <div className={css.rbModalTitle}>Call Litigator?</div>
                                    <div className={css.rbModalDetails}>
                                        This person is a Litigator. Are you sure you want <br />
                                        to proceed?
                                    </div>
                                </div>
                            )}

                            <div className={css.buttonRemoveWrapper}>
                                <button className={css.cancelRemoveBtn} onClick={onClose}>
                                    <span className={css.cancelRemoveLabel}>Cancel</span>
                                </button>
                                <button className={classNames(css.connectBtn, { [css.noClick]: isSubmitting })}
                                  onClick={onSuccess}>
                                    <span>Proceed</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default CallDncLitigator;